var IPHONE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPod;|iPod touch;)/;
var IPAD_USER_AGENT = /iPad;/;
export function isIPhone() {
  var _navigator;
  if (!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.userAgent) !== null && _navigator !== void 0 && _navigator.length)) {
    return false;
  }
  return IPHONE_USER_AGENT.test(navigator.userAgent);
}
export function isIPad() {
  var _navigator2, _navigator3;
  if (!navigator || !((_navigator2 = navigator) !== null && _navigator2 !== void 0 && (_navigator2 = _navigator2.userAgent) !== null && _navigator2 !== void 0 && _navigator2.length) || !((_navigator3 = navigator) !== null && _navigator3 !== void 0 && (_navigator3 = _navigator3.platform) !== null && _navigator3 !== void 0 && _navigator3.length)) {
    return false;
  }
  var _navigator4 = navigator,
    userAgent = _navigator4.userAgent,
    platform = _navigator4.platform,
    maxTouchPoints = _navigator4.maxTouchPoints;

  // Check for iPad using user agent
  var isIPadUserGgent = IPAD_USER_AGENT.test(userAgent);

  // Check for iPad in desktop mode (iOS 13+)
  var isIPadDesktop = platform === 'MacIntel' && maxTouchPoints > 1;
  return isIPadUserGgent || isIPadDesktop;
}